import * as React from 'react';
import styled from 'styled-components';

 const Contact = styled.div`
        display: flex;
        flex-direction: column;
        justify-content: center;
        background-color: #1a1a1a;
        color: white;
        margin: 1.5em 0;
        width: 100%;

        .title {
            justify-self: flex-start;
            margin-top: -.5em;
            text-transform: uppercase;
            font-style: italic;
            font-weight: bold;
            font-size: 24px;
            font-family: "Roboto Condensed", sans-serif;
        }

        .enquiry-body {
            text-align: center;
            font-size: 16px;
            font-family: 'Roboto', sans-serif;
            margin: 1.5em auto;
            width: 90%;
            line-height: 1.43;
        }

        .enquiry-button {
            color: #000;
            background-color: #3ee9f7;
            width: 120px;
            height: 36px;
            text-transform: uppercase;
            font-style: italic;
            font-size: 16px;
            font-weight: bold;
            font-family: "Roboto Condensed", sans-serif;
            border: none;
            margin: 1em auto 2em auto;
            border-radius: 2px;
        }

        .enquiry-button:hover {
            background-color: #08b8c7;
        }
    `
// contact or faq component
// may need to be split into two seperate components later
const Enquiry = props => {
   
    return (
      <Contact>
        <h2 className="title">NEED A PIT STOP?</h2>
        <p className="enquiry-body">
          {" "}
          Check out tons of valuable coaching in the Performance Learning Pit
          Stop
        </p>
        <button
          className="enquiry-button blue-button"
          onClick={props.toHelpCenter}
        >
          Check In
        </button>
      </Contact>
    );
}
export default Enquiry;


// WEBPACK FOOTER //
// ./src/common/enquiries.Component.tsx